const article = {
	slug: "github-pages-hosting-utility",
	title: "GitHub Pages Hosting: A Small Utility for a Common Pain Point",
	date: "6 July 2025",
	updated: null,
	description:
		"A one-page tool to find which of your repos is serving GitHub Pages. A small utility, but a clean example of noticing friction, not overengineering, and shipping.",
	keywords: [
		"GitHub Pages",
		"developer tools",
		"web hosting",
		"side projects",
	],
	tldr: "Noticing friction, validating the problem, deciding not to overengineer, shipping and moving on. Sometimes the most valuable tool is the basic one that removes friction.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, July 2025.",
	provenanceUrl: null,
	series: null,
	artifact: null,
	markdown: `Breaking my own website was not on the agenda this week. But here we are. I ended up building a micro utility to solve a common low-cost hosting pain point.

I accidentally brought down my personal portfolio website. Then, in trying to fix it, I made it worse. The site is still under maintenance.

While trying to set up a low-cost hosting workaround, I ran into a surprisingly common GitHub Pages issue: figuring out which of my 100+ repositories was already hosting a GitHub Pages site. GitHub allows you to host only one repo as a website at a time. There is no easy way to find out which one it is.

A quick search on Stack Overflow and Reddit showed I was not alone, and that it is a recurring pain point.

So I built a simple one-page tool. Enter a GitHub username, instantly see which repo is using GitHub Pages, then remove it from the old repo.

At first, I thought it was too trivial to share. But then I realized this is exactly the kind of process I, and many of my peers, want to practice and repeat at scale with our teams:

- Noticing friction
- Validating the problem
- Deciding not to overengineer
- Shipping and moving on

It is basic, but it removes friction. And sometimes, that is the most valuable kind of tool. It is also a small win for students and for developers on a budget. It is for anyone who wants to quickly prototype or host a site using GitHub's free static hosting without spending hours guessing where it lives.

And because I could not resist a little extra, I added a few AI-powered tips for other free hosting options too, for those just starting out or building on the side.`,
};

export default article;
